
const initState = {};

const UserDataReducer = (state = initState, action) => {
    switch(action.type) {
        case  'UserData' : return  action.payload;
        default: return state;
    }
}
export default UserDataReducer;